import { statusLabel, statusTone, type Tone } from '@/lib/labels'
import { cn } from '@/lib/utils'

const TONES: Record<Tone, string> = {
  success: 'bg-[var(--tone-success-bg)] text-[var(--tone-success-fg)]',
  warning: 'bg-[var(--tone-pending-bg)] text-[var(--tone-pending-fg)]',
  danger: 'bg-[var(--tone-danger-bg)] text-[var(--tone-danger-fg)]',
  info: 'bg-[var(--tone-info-bg)] text-[var(--tone-info-fg)]',
  neutral: 'bg-[var(--tone-neutral-bg)] text-[var(--tone-neutral-fg)]',
}

/** Tone plus a mark (ring, dotted ring, tick, cross), so status reads without colour. */
export default function StatusBadge({ status, className }: { status?: string | null; className?: string }) {
  if (!status) return <span className="text-muted-foreground">—</span>
  const tone = statusTone(status)
  return (
    <span
      data-tone={tone}
      className={cn(
        'status-badge inline-flex items-center gap-1.5 rounded px-2 py-px text-[12.5px] font-semibold whitespace-nowrap',
        TONES[tone],
        className,
      )}
    >
      {statusLabel(status)}
    </span>
  )
}
